const PAYMENT_FALLBACK_ALERT_PREFIX = "fallback_alert";

export const PAYMENT_FALLBACK_ALERT_TEST_IDS = {
    TITLE: `${PAYMENT_FALLBACK_ALERT_PREFIX}_title`,
    PAYMENT_METHODS_CONTAINER: `${PAYMENT_FALLBACK_ALERT_PREFIX}_payment_methods_container`,
    PRIMARY_ACTION_BUTTON: `${PAYMENT_FALLBACK_ALERT_PREFIX}_primary_btn`,
    CLOSE_ICON: `${PAYMENT_FALLBACK_ALERT_PREFIX}_close_icon`,
};
